
export const useStyles = () => {

    return {

        cancelStyles: {
            width: { width: '430px' }
        },
        mainContainer: {
            display: 'flex',
            width: '100%',
            minHeight: '70vh',
            gap:1,
        },
        map: (expandMap:boolean) => ({
            width: '100%',
            minHeight: '100px',
            overflow: 'hidden',
            transition: 'max-width 0.5s ease, opacity 0.5s ease',
            maxWidth: expandMap ? '55%' : 0,
            opacity: expandMap ? 1 : 0,
            visibility: expandMap ? 'visible' : 'hidden',
        }),
        containerUser: (expandMap:boolean) => ({
            width:expandMap ? '45%' : '100%'
        }),
        containerMap:{
            height:'93%'
        },
        seeButons: {
            textDecoration: 'underline',
            marginTop:'2px'
        },
        containerHidenButon:{
            display:'flex',
            justifyContent:'flex-end',
        },
        mapContainer: { 
            height: '100%', 
            width: '100%' 
        },
        mapModal:{
            width: '60vw',
            padding: 2,
            height: '600px',
        },
    }
}